import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=03fa47cc&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03fa47cc')) {
      api.createRecord('03fa47cc', component.options)
    } else {
      api.reload('03fa47cc', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=03fa47cc&", function () {
      api.rerender('03fa47cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-258xmjW425xN6/JS/comp/openstreetmap.vue"
export default component.exports